import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import isFunction from 'lodash/isFunction';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import isUndefined from 'lodash/isUndefined';
import round from 'lodash/round';
import ceil from 'lodash/ceil';

import './colorSelector.scss';

class ColorSelectorCtrl {
    constructor(config, dataService, imagesService, notificationService, $scope, ncsService, $rootScope, $translate) {
        this.dataService = dataService;
        this.imagesService = imagesService;
        this.ncsService = ncsService;
        this.notificationService = notificationService;

        this.config = config;
        this.searchString = '';
        this.palette = {};
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.firstCustomSelection = false;
        this.colorPalettes = [];
        this.inner = null;
        this.outer = null;
        this.predefinedColor = {};

        this.selectedPredefinedCombinations = true;
        this.predefinedCombinations = [];
        this.customCombinations = [];
        this.palettesOutside = [];
        this.palettesInside = [];
        this.defaultInnerColorId = this.dataService.getAttribute('defaultInnerColorId');
        this.defaultOuterColorId = this.dataService.getAttribute('defaultOuterColorId');
        this.defaultGlazingSpacers = this.dataService.getAttribute('defaultGlazingSpacerForColors');
        this.outsideActive = true;
        this.selectedCustomCombinationId = null;
        this.matchedCustomCombination = null;
        this.selectedPredefinedCombinationId = null;
        this.selectedPalette = null;
        this.outsideNcsCode = '';
        this.insideNcsCode = '';
        this.availableColors = null;
        this.innerColorPrice = 0;
        this.outerColorPrice = 0;
        this.blockDifferentColors = true;
        this.showDefaultColors = false;

        $translate('GLAZING_SPACER_COLOR_CHANGE_INFO').then((infoText) => {
            this.glazingSpacerColorChangeInfo = infoText;
        });
    }

    onInit() {
        this.getPalettes();
        this.options = this.getFilteredColorsByAvailablePalettes();
        this.setInitialColors();
        this.getPredefinedCombinations();
        this.getCustomCombinations();
        this.setInitialCustomCombination();
        this.setSelectedPalette();
        this.calculateColorsPrice();
        this.getOutsidePalette();
        this.getInsidePalette();
        this.showDefaultColors = this.dataService.data.productInfo.showDefaultColors;

        if (this.predefinedCombinations.length == 0) {
            this.selectedPredefinedCombinations = false;
        }
    }

    getFilteredColorsByAvailablePalettes() {
        const allPalettesIds = [];
        let options = [];
        this.colorPalettes.forEach(palette => allPalettesIds.push(palette.id));
        options = this.options.filter(color => color.attributes.paletteIds.some(el => allPalettesIds.indexOf(el) > -1));

        return options;
    }

    setInitialColors() {
        const currentInsideColorId = this.dataService.getSelectedOptionId('inner');
        const currentOutsideColorId = this.dataService.getSelectedOptionId('outer');
        this.inner = this.getColorDataById(currentInsideColorId);
        this.outer = this.getColorDataById(currentOutsideColorId);
    }

    setInitialCustomCombination() {
        if (!this.selectedCustomCombinationId) {
            if (this.dataService.data.data[0].relationships.customCombination.data.id) {
                this.selectedCustomCombinationId = this.dataService.data.data[0].relationships.customCombination.data.id;
            } else if (this.customCombinations.length > 0) {
                this.selectedCustomCombinationId = this.customCombinations[0].id;
            }
        }
    }

    getPalettes() {
        this.colorPalettes = this.dataService.getAttributeOptions('colorPalettes');
    }

    getColorsFromSelectedPalette() {
        const allColors = this.selectedPalette ?
            this.options.filter(el => el.attributes.paletteIds.indexOf(this.selectedPalette.id) > -1) : [];
        if (this.isNcs()) {

            let colors = null;
            if (this.outsideActive) {
                colors = this.searchNcs('outside');
            } else {
                colors = this.searchNcs('inside');
            }
            this.availableColors = colors;
            return true;
        }
        const filteredColor = [];
        if (this.searchString != '') {
            const regExp = new RegExp(`${this.searchString.toLowerCase()}`);

            allColors.forEach((el) => {
                if (el.attributes.name.toLowerCase().match(regExp)) {
                    filteredColor.push(el);
                } else if (el.attributes.ral && el.attributes.ral.match(regExp)) {
                    filteredColor.push(el);
                }
            });
            this.availableColors = filteredColor;
            return true;
        } else {
            this.availableColors = allColors;
            return true;
        }
    }

    searchNcs(side = 'outside') {
        const NCSPaletteId = this.selectedPalette.id;
        const NCSColors = this.options.filter(el => el.attributes.paletteIds.indexOf(NCSPaletteId) > -1);
        const filteredColor = [];

        if (side === 'inside') {
            if (this.insideNcsCode == '') {
                return null;
            }
            const regExp = new RegExp(`^${this.insideNcsCode.toLowerCase()}`);

            NCSColors.forEach((el) => {
                if (el.attributes.name.toLowerCase().match(regExp)) {
                    filteredColor.push(el);
                }
            });
            return filteredColor;
        }
        if (side === 'outside') {

            if (this.outsideNcsCode == '') {
                return null;
            }
            const regExp = new RegExp(`^${this.outsideNcsCode.toLowerCase()}`);

            NCSColors.forEach((el) => {
                if (el.attributes.name.toLowerCase().match(regExp)) {
                    filteredColor.push(el);
                }
            });
            return filteredColor;
        }
    }

    setSelectedPalette() {
        if (this.outsideActive) {
            this.selectedPalette = this.getAvailableOuterColorPalette();
        } else {
            this.selectedPalette = this.getAvailableInnerColorPalette();
        }

        this.getColorsFromSelectedPalette();
    }

    isNcs() {
        const colorPalettes = this.dataService.getAttributeOptions('colorPalettes');
        const NCSPalettes = filter(colorPalettes, el => el.name.toUpperCase() === 'NCS');

        const NCSPalette = find(NCSPalettes, el => el.id === this.selectedPalette.id);

        return !isUndefined(NCSPalette);
    }

    getPredefinedCombinations() {
        this.predefinedCombinations = this.dataService.getAttributeOptions('predefinedCombination');
    }

    getCustomCombinations() {
        this.customCombinations = this.dataService.getAttributeOptions('customCombination');
    }

    setPredefinedCombinations(value) {
        this.selectedPredefinedCombinations = value;
        if (value === false && this.selectedPredefinedCombinationId) {
            this.reset();
            this.selectedPredefinedCombinationId = null;
        }
    }

    calculateDiscountedPrice(price) {
        const discount = price * (this.dataService.discountPercentageValue / 100);
        return price - discount;
    }

    calculateColorsPrice() {
        // Calculate price for door colors
        if (this.dataService.getProductType() === 'door') {
            const standardDoorColorsIds = this.dataService.getAttributeOptions('standardColors').map(color => color.id);
            const fieldsCount = this.dataService.getAttribute('standardFields');
            const entranceDoorColorPrices = this.dataService.getAttribute('entranceDoorColorPricesInfo');
            let colorIsDoorStandardColor = false;
            if (standardDoorColorsIds.indexOf(this.outer.id) > -1) {
                colorIsDoorStandardColor = true;
            }

            if (this.inner.id === this.defaultInnerColorId && this.outer.id === this.defaultOuterColorId) {
                this.innerColorPrice = 0;
                this.outerColorPrice = 0;
                return true;
            }

            if (this.inner.id === this.outer.id && colorIsDoorStandardColor) {
                this.innerColorPrice = 0;
                this.outerColorPrice = ceil(this.calculateDiscountedPrice(entranceDoorColorPrices[fieldsCount]['standardColor']));
                return true;
            }

            if (this.inner.id === this.outer.id && !colorIsDoorStandardColor) {
                this.innerColorPrice = 0;
                this.outerColorPrice = ceil(this.calculateDiscountedPrice(entranceDoorColorPrices[fieldsCount]['nonStandardColor']));
                return true;
            }

            this.innerColorPrice = ceil(this.calculateDiscountedPrice(entranceDoorColorPrices[fieldsCount]['colorTwoSides'] / 2));
            this.outerColorPrice = ceil(this.calculateDiscountedPrice(entranceDoorColorPrices[fieldsCount]['colorTwoSides'] / 2));
            return true;
        }

        if (this.inner.id === this.defaultInnerColorId && this.outer.id === this.defaultOuterColorId) {
            this.innerColorPrice = 0;
            this.outerColorPrice = 0;
            return true;
        }

        // calculate from predefined
        if (this.selectedPredefinedCombinations && this.selectedPredefinedCombinationId) {
            const selectedPredefinedCombination = this.predefinedCombinations.find(elem => elem.id == this.selectedPredefinedCombinationId);
            if (!isUndefined(selectedPredefinedCombination) && this.dataService.freshPrice) {
                const percentage = selectedPredefinedCombination.attributes.precentageSurchargeSingleColor + selectedPredefinedCombination.attributes.precentageSurchargeBiColor;
                const price = this.calculatePrice(percentage);
                if (this.inner.id === this.defaultInnerColorId) {
                    this.innerColorPrice = 0;
                    this.outerColorPrice = ceil(price);
                } else if (this.outer.id === this.defaultOuterColorId) {
                    this.innerColorPrice = ceil(price);
                    this.outerColorPrice = 0;
                } else {
                    this.innerColorPrice = ceil(price / 2);
                    this.outerColorPrice = ceil(price / 2);
                }
            }
        } else {
            const combinationData = this.customCombinations.find(elem => elem.id === this.selectedCustomCombinationId);
            if (combinationData) {
                let price = 0;
                if (this.inner.id === this.outer.id || this.inner.id === this.defaultInnerColorId || this.outer.id === this.defaultOuterColorId) {
                    price = this.calculatePrice(combinationData.attributes.precentageSurchargeSingleColor);
                } else {
                    price = this.calculatePrice(combinationData.attributes.precentageSurchargeBiColor);
                }

                if (this.inner.id === this.defaultInnerColorId) {
                    this.innerColorPrice = 0;
                    this.outerColorPrice = ceil(price);
                } else if (this.outer.id === this.defaultOuterColorId) {
                    this.innerColorPrice = ceil(price);
                    this.outerColorPrice = 0;
                } else {
                    this.innerColorPrice = ceil(price / 2);
                    this.outerColorPrice = ceil(price / 2);
                }
                return false;
            }
            this.innerColorPrice = '';
            this.outerColorPrice = '';
            return false;
        }
        return false;
    }

    matchCombinationWithSelectedOutsideColor(setInsideColor = false) {
        this.matchedCustomCombination = null;

        if (this.matchCurrentCombination()) {
            return true;
        }

        if (this.matchCombinationWithOneSpecificColor(setInsideColor)) {
            return true;
        }

        if (this.matchCombinationBasedOnInnerOuterPalette(setInsideColor)) {
            return true;
        }

        this.matchCombinationBasedOnOuterPalette(setInsideColor)
    }

    matchCombinationWithOneSpecificColor(setInsideColor) {
        this.matchedCustomCombination = this.customCombinations.find(elem => (
            ((elem.relationships.paletteInner.data.colorId === this.inner.id && elem.relationships.paletteOuter.data.colorId === -1) ||
                (elem.relationships.paletteInner.data.colorId === -1 && elem.relationships.paletteOuter.data.colorId === this.outer.id)) &&
            this.checkIfColorsMatchesPalette(elem)
        ));

        if (this.matchedCustomCombination) {
            this.selectedCustomCombinationId = this.matchedCustomCombination.id;
            this.dataService.data.data[0].relationships.customCombination.data.id = this.matchedCustomCombination.id;
            if (setInsideColor) {
                this.setInsideColorFromMatchedPalette('inside');
            }
            return true;
        }

        return false;
    }

    matchCurrentCombination() {
        const currentCombinationData = this.customCombinations.find(elem => elem.id === this.selectedCustomCombinationId);
        if (
            this.checkIfColorsMatchesPalette(currentCombinationData) &&
            this.checkPossibleColorsInCombination(currentCombinationData)
        ) {
            this.matchedCustomCombination = currentCombinationData;
            this.dataService.data.data[0].relationships.customCombination.data.id = this.matchedCustomCombination.id;
            return true;
        }

        return false;
    }

    checkPossibleColorsInCombination(combination) {
        return (
            (combination.relationships.paletteOuter.data.colorId === -1 && combination.relationships.paletteInner.data.colorId === -1) ||
            (combination.relationships.paletteOuter.data.colorId === this.outer.id && combination.relationships.paletteInner.data.colorId === -1) ||
            (combination.relationships.paletteOuter.data.colorId === -1 && combination.relationships.paletteInner.data.colorId === this.inner.id)
        );
    }

    checkIfColorsMatchesPalette(combination) {
        return (
            this.inner.attributes.paletteIds.indexOf(combination.relationships.paletteInner.data.id) > -1 &&
            this.outer.attributes.paletteIds.indexOf(combination.relationships.paletteOuter.data.id) > -1
        );
    }

    matchCombinationBasedOnInnerOuterPalette(setInsideColor) {
        for (const i in this.customCombinations) {
            if (
                this.inner.attributes.paletteIds.indexOf(this.customCombinations[i].relationships.paletteInner.data.id) > -1 &&
                this.outer.attributes.paletteIds.indexOf(this.customCombinations[i].relationships.paletteOuter.data.id) > -1
            ) {
                this.matchedCustomCombination = this.customCombinations[i];
                this.selectedCustomCombinationId = this.matchedCustomCombination.id;
                this.dataService.data.data[0].relationships.customCombination.data.id = this.matchedCustomCombination.id;
                if (setInsideColor) {
                    this.getInsidePalette();
                }
                return true;
            }
        }

        return false;
    }

    matchCombinationBasedOnOuterPalette(setInsideColor) {
        const customCombinationsToFilter = this.customCombinations.filter(elem => elem.id !== this.selectedCustomCombinationId);
        const outerPalettes = this.outer.attributes.paletteIds;
        for (let index = 0; index < outerPalettes.length; index++) {
            this.matchedCustomCombination = customCombinationsToFilter.find(elem => (
                    elem.relationships.paletteOuter.data.id === this.outer.attributes.paletteIds[index]) &&
                (elem.relationships.paletteOuter.data.colorId === this.outer.id ||
                    elem.relationships.paletteOuter.data.colorId === -1)
            );
            if (this.matchedCustomCombination) {
                break;
            }
        }

        if (this.matchedCustomCombination) {
            this.selectedCustomCombinationId = this.matchedCustomCombination.id;
            this.dataService.data.data[0].relationships.customCombination.data.id = this.matchedCustomCombination.id;
            if (setInsideColor) {
                this.setInsideColorFromMatchedPalette('inside');
            }
            return true;
        }

        return false;
    }

    calculatePrice(surcharge) {
        let basePrice = this.dataService.basePrice;
        basePrice = (this.dataService.isB2bMode() && !this.dataService.priceSwitchState()) ? basePrice / 1.25 : basePrice;
        const price = basePrice * surcharge;
        const discount = price * (this.dataService.discountPercentageValue / 100);
        return price - discount;
    }

    getAvailableInnerColorPalette() {
        if (this.customCombinations.length > 0) {
            const customCombination = this.customCombinations.find(el => el.id == this.selectedCustomCombinationId);
            const paletteId = customCombination.relationships.paletteInner.data.id;
            const colorPalette = this.colorPalettes.find(palette => palette.id == paletteId);
            return colorPalette;
        }
        return null;
    }

    getAvailableOuterColorPalette() {
        if (this.customCombinations.length > 0) {
            const customCombination = this.customCombinations.find(el => el.id == this.selectedCustomCombinationId);
            const paletteId = customCombination.relationships.paletteOuter.data.id;
            const colorPalette = this.colorPalettes.find(palette => palette.id == paletteId);
            return colorPalette;
        }
        return null;
    }

    getColorDataById(id) {
        return this.options.find(color => color.id === id);
    }

    getColorProperty(id, fieldName) {
        if (id) {
            const color = find(this.options, el => el.id === id);
            return color.attributes[fieldName];
        }
        if (fieldName === 'imgSrc') {
            return null;
        }
        return 'unset';
    }

    getImageUrl(imgSrc) {
        if (imgSrc) {
            return this.imagesService.getFullUrl(imgSrc);
        }

        return '/img/no-image.jpg';
    }

    setCustomColor(color) {
        if (this.outsideActive) {
            this.outer = color;

            // set same both colors for door until we select outside/inside color preview
            if (this.dataService.getProductType() === 'door' && this.blockDifferentColors) {
                this.inner = color;
                this.dataService.updateSelectedOptions('inner', [color.id], null, false);
            } else {
                this.matchCombinationWithSelectedOutsideColor(true);
            }
            this.dataService.updateSelectedOptions('outer', [color.id], null, false);
            this.setDefaultGlazingSpacerColor(color.attributes.isWhite);
            this.dataService.validateDimensionColorRule();
        } else {
            this.inner = color;
            this.dataService.updateSelectedOptions('inner', [color.id], null, false);
            this.dataService.updateSelectedOptions('seal', [color.attributes.sealColourId], 'seal', false);

            if ((this.dataService.getProductType() === 'door') && this.inner.id !== this.defaultInnerColorId) {
                this.outer = color;
                this.dataService.updateSelectedOptions('outer', [color.id], null, false);
                this.setDefaultGlazingSpacerColor(color.attributes.isWhite);
            }

            if (this.dataService.getProductType() !== 'door') {
                this.matchCombinationWithSelectedOutsideColor();
            }
        }
        this.dataService.setMuntinColorBasedOnConstructionColor();
        this.calculateColorsPrice();
        this.$rootScope.$emit('colorChangeEvent');
    }

    closeBox() {
        if (isFunction(this.closeBoxCallback)) {
            this.closeBoxCallback();
        }
        this.selectedOptionId = null;
    }

    selectOutsideColor(value) {
        if (this.outsideActive !== value) {
            this.outsideActive = value;
        }
        this.setSelectedPalette();
    }

    setColorsFromPredefinedCombination(colorCombination, refreshPrice = true) {
        if (colorCombination.relationships) {
            const inner = colorCombination.relationships.colorInner.data;
            const outer = colorCombination.relationships.colorOuter.data;
            this.inner = this.getColorDataById(inner.id);
            this.outer = this.getColorDataById(outer.id);

            this.dataService.updateSelectedOptions('inner', [inner.id], null, false);
            this.dataService.updateSelectedOptions('seal', [this.inner.attributes.sealColourId], 'seal', false);
            this.dataService.updateSelectedOptions('outer', [outer.id], null, false);
            this.setDefaultGlazingSpacerColor(this.outer.attributes.isWhite);
            this.selectedPredefinedCombinationId = colorCombination.id;

            this.dataService.data.data[0].relationships.predefinedCombination.data.id = this.selectedPredefinedCombinationId;
            this.dataService.data.data[0].relationships.customCombination.data.id = null;

            this.dataService.setMuntinColorBasedOnConstructionColor();
            this.calculateColorsPrice();
            if (refreshPrice) {
                this.$rootScope.$emit('colorChangeEvent');
            }
            this.dataService.validateDimensionColorRule();
        }
    }

    reset(side = null) {
        if (side === 'inner' || side == null) {
            this.inner = this.options.find(color => color.id === this.defaultInnerColorId);
            this.dataService.updateSelectedOptions('inner', [this.inner.id], null, false);
            this.dataService.updateSelectedOptions('seal', [this.inner.attributes.sealColourId], 'seal', false);
        }
        if (side === 'outer' || side == null) {
            this.outer = this.options.find(color => color.id === this.defaultOuterColorId);
            this.dataService.updateSelectedOptions('outer', [this.outer.id], null, false);
            this.setDefaultGlazingSpacerColor(this.outer.attributes.isWhite);
        }
        if (side == null) {
            this.blockDifferentColors = true;
            this.outsideActive = true;
        }

        this.dataService.data.data[0].relationships.predefinedCombination.data.id = null;
        this.dataService.data.data[0].relationships.customCombination.data.id = null;

        this.dataService.setMuntinColorBasedOnConstructionColor();
        this.calculateColorsPrice();
        this.$rootScope.$emit('colorChangeEvent');
    }

    setDefaultGlazingSpacerColor(isWhite) {
        if (
            this.defaultGlazingSpacers &&
            this.dataService.hasGlazingSpacers() &&
            !this.dataService.isDefaultGlazingSpacerAluminium()
        ) {
            if (isWhite) {
                this.dataService.updateSelectedOptions('glazingSpacers', this.defaultGlazingSpacers['white'], 'glazingSpacers', true);
            } else {
                this.dataService.updateSelectedOptions('glazingSpacers', this.defaultGlazingSpacers['other'], 'glazingSpacers', true);
            }
            this.notificationService.displayNotificationInConfigurator(this.glazingSpacerColorChangeInfo);
        }
    }

    getOutsidePalette() {
        this.customCombinations.forEach((combination) => {
            let colorPalette = this.colorPalettes.filter(color => color.id === combination.relationships.paletteOuter.data.id)[0];
            if (colorPalette) {
                this.palettesOutside.push({
                    id: colorPalette.id,
                    name: colorPalette.name
                });
            }
        });

        this.palettesOutside = [...new Map(this.palettesOutside.map(item => [item['id'], item])).values()];
    }

    getInsidePalette() {
        let filterCombinations = this.customCombinations.filter(combination => combination.id === this.selectedCustomCombinationId ||
            this.selectedPalette.id === combination.relationships.paletteOuter.data.id);

        let palettesTmp = [];
        filterCombinations.forEach((combination) => {
            let colorPalette = this.colorPalettes.filter(color => color.id === combination.relationships.paletteInner.data.id)[0];
            if (colorPalette) {
                palettesTmp.push({
                    id: colorPalette.id,
                    name: colorPalette.name
                });
            }
        });

        this.palettesInside = [...new Map(palettesTmp.map(item => [item['id'], item])).values()];
    }

    changeColorPalette(colorPalette) {
        this.selectedPalette = this.colorPalettes.find(palette => palette.id === colorPalette.id);
        this.getColorsFromSelectedPalette();
    }

    setInsideColorFromMatchedPalette() {
        this.getInsidePalette();
        const selectedCombination = this.matchedCustomCombination;

        const innerPalette = this.colorPalettes.filter(color => color.id === selectedCombination.relationships.paletteInner.data.id)[0];
        let colorsInPalette = this.selectedPalette ?
            this.options.filter(el => el.attributes.paletteIds.indexOf(innerPalette.id) > -1) : [];

        if (colorsInPalette) {
            this.inner = colorsInPalette[0];
            this.dataService.updateSelectedOptions('inner', [colorsInPalette[0].id], null, false);
        }
    }
}

ColorSelectorCtrl.$inject = ['config', 'dataService', 'imagesService', 'notificationService', '$scope', 'ncsService', '$rootScope', '$translate'];

export default ColorSelectorCtrl;